import { render, staticRenderFns } from "./DigitalItems.vue?vue&type=template&id=b98e4264"
import script from "./DigitalItems.vue?vue&type=script&lang=js"
export * from "./DigitalItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports